(function () {
  if(document.body.id !== 'top') return false

  var slider = document.querySelector('.js-top-pickup-slider')
  setSwiper(slider)

  swiper= new Swiper('.js-top-pickup-slider', {
    loop: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    loopedSlides: 0,
    speed: 1000,
    // autoplay: {
    //   delay: 8000,
    //   disableOnInteraction: false
    // },
    navigation: {
      nextEl: '.js-top-pickup-next',
      prevEl: '.js-top-pickup-prev',
    },
    pagination: {
      el: ".js-top-pickup-pagination",
      clickable: true
    }
  })

  function setSwiper(slideContainer) {
    slideContainer.classList.add('swiper')
    var slideWrapper = slideContainer.querySelector('.wrapper')
    slideWrapper.classList.add('swiper-wrapper')
    var slide = slideWrapper.querySelectorAll('.slide')
    for (var i = 0; i < slide.length; i++) {
      slide[i].classList.add('swiper-slide')
    }
  }

}());